import { renderSafeMarkdown, renderMarkdownWithFileLinks } from "../markdown";

interface Props {
  role: "user" | "assistant" | "tool";
  content: string;
  streaming?: boolean;
  showLabel?: boolean;
  fileLinks?: boolean;
}

export function ChatMessage({
  role,
  content,
  streaming,
  showLabel = true,
  fileLinks = false,
}: Props) {
  // Only linkify once a message has SETTLED. While streaming, re-running the
  // file-link regex per token is O(n^2) on long no-slash runs (base64/hashes)
  // and would freeze the UI; the spec resolves links once the message settles.
  const useFileLinks = fileLinks && !streaming;
  const render = useFileLinks ? renderMarkdownWithFileLinks : renderSafeMarkdown;
  const safe = role === "assistant" || role === "tool" ? render(content) : null;
  // Bubble style (iMessage/Codex-app): user right-aligned in an accent bubble,
  // assistant/tool left-aligned in a neutral bubble. The `.chat-msg--*` classes
  // carry the bubble look; we no longer apply the old `chat-message--flat*`
  // override that flattened them to transparent plain text.
  return (
    <article role="article" className={`chat-msg chat-msg--${role}`}>
      {showLabel && (
        <div className="chat-msg__role" aria-hidden>
          {role}
        </div>
      )}
      {safe ? (
        <div className="chat-msg__body" dangerouslySetInnerHTML={{ __html: safe }} />
      ) : (
        <div className="chat-msg__body">{content}</div>
      )}
      {streaming && (
        <span className="chat-msg__cursor" aria-hidden>
          ▍
        </span>
      )}
    </article>
  );
}
